import React, { Component }  from 'react';
import Heading from '../Components/heading';
export default (props) => { 
    let {data} = props;
    return (
        <React.Fragment>
            <Heading {...props} data={data} />
        </React.Fragment>
    ) 
}



// WEBPACK FOOTER //
// ./src/components/Journals/Details/Layouts/Custom/header_text_module.js